import { useCallback, useState } from 'react'
import { useSearchQuery } from '../store/globalSearch.service'
import React from 'react'
import { usePreviousSearches } from './usePreviousSearches'

export const useGlobalSearch = () => {
  const { setPreviousSearch } = usePreviousSearches()
  const [query, setQuery] = useState<string>('')
  const [debouncedQuery, setDebouncedQuery] = useState<string>('')
  const debounceTime = 200
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null)

  const resetSearch = useCallback(() => {
    setQuery('')
    setDebouncedQuery('')
  }, [])

  const handleSearchChange = useCallback(
    (newQuery: string) => {
      if (newQuery.length < 3) {
        setQuery('')
        setDebouncedQuery('')
        return
      }

      if (timeoutRef.current) clearTimeout(timeoutRef.current)

      timeoutRef.current = setTimeout(() => {
        setQuery(newQuery)
        setDebouncedQuery(newQuery)
        setPreviousSearch(newQuery)
      }, debounceTime)
    },
    [debounceTime, setPreviousSearch]
  )

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])
  const { data, isFetching, isLoading, error } = useSearchQuery({
    searchQuery: debouncedQuery,
    params: [],
  })
  const loading = isFetching || isLoading

  return { data, loading, error, query, handleSearchChange, resetSearch }
}
